import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a67cc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系我们", -1))
const _hoisted_3 = ["src"]

import { ref, computed } from "vue";
import { CloseBold } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCode',
  props: {
  showQRCode: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props;

let img = require("@/assets/market.png");
let img1 = require("@/assets/images/showQR.png"); // 向左的箭头



const isMobile = ref(window.innerWidth < 768); // 判断是否是移动端

const isAtBottom = ref(false);

// 监听窗口大小变化
window.addEventListener("resize", () => {
  isMobile.value = window.innerWidth < 768;
});

// 鼠标移入事件（切换右上角和右下角显示）
const handleMouseEnter = () => {
  isAtBottom.value = !isAtBottom.value;
};

const handleMouseLeave = () => {};

// 根据 `isMobile.value` 和 `isAtBottom.value` 的值来决定content的样式。
const contentStyle = computed(() => {
  return {
    transition: isMobile.value ? "none" : "top 1s ease",
    top: isAtBottom.value && !isMobile.value ? "72vh" : "30vh",
  };
});

const isQrVisible = ref(true); // 默认二维码是可见的

// 计算属性，结合showQRCode和isQrVisible的条件
const shouldShowQRCode = computed(() => props.showQRCode && isQrVisible.value);

function toggleVisibility() {
  isQrVisible.value = !isQrVisible.value; // 切换二维码的可见状态
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(shouldShowQRCode))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["content", { bottom: isAtBottom.value && !isMobile.value }]),
          onMouseenter: handleMouseEnter,
          onMouseleave: handleMouseLeave,
          style: _normalizeStyle(_unref(contentStyle))
        }, [
          _withDirectives(_createElementVNode("div", {
            class: "close-btn",
            onClick: toggleVisibility
          }, [
            _createVNode(_component_el_icon, {
              size: 14,
              color: "#9E9E9E"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CloseBold))
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, isMobile.value]
          ]),
          _createElementVNode("img", {
            src: _unref(img),
            alt: "二维码"
          }, null, 8, _hoisted_1),
          _hoisted_2
        ], 38))
      : _createCommentVNode("", true),
    (!isQrVisible.value && isMobile.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "arrow-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isQrVisible.value = true))
        }, [
          _createElementVNode("img", {
            src: _unref(img1),
            alt: "显示二维码"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})